'use client';
import { useLoginDialogStore } from '@wwe-portal/widget/auth';
import { ScopelyLogin } from '../auth/scopely-login';
import { FacebookLogin } from '../auth/facebook-login';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';
import {
  generalSubscriptionInformation,
  useSubscriptionQuery,
} from '@wwe-portal/web/providers/queries/subscription';
import { useSubscriptionMutation } from '@wwe-portal/web/providers/queries/subscription.mutation';
import { SubscriptionConsumer } from './consumer';
import { SubscriptionProvider } from './provider';

export const SubscriptionPageContent = () => {
  const isAuthenticated = useIsAuthenticated();

  const { plans, currentPlan, isLoading } = useSubscriptionQuery();

  const { mutation, upgradeDialogState } = useSubscriptionMutation({
    currentPlan: currentPlan || null,
  });

  const loginState = useLoginDialogStore({
    title: 'Login To Subscribe',
    isAuthenticated,
    loginButtons: (
      <>
        <FacebookLogin />
        <ScopelyLogin />
      </>
    ),
  });

  return (
    <div className="pt-5">
      <SubscriptionProvider
        data={{
          ...generalSubscriptionInformation,
          plans: plans?.reverse(),
        }}
        isLoading={isLoading}
        currentPlan={currentPlan}
        mutation={{
          ...mutation,
          subsribe(data) {
            if (!isAuthenticated) {
              loginState.show();
              return;
            }
            mutation.subsribe(data);
          },
        }}
        changeDialogState={upgradeDialogState}
        loginState={loginState}
      >
        <SubscriptionConsumer />
      </SubscriptionProvider>
    </div>
  );
};
